<template>
	<div class="stock_table">
		<div class="table">
			<el-table :height="590" ref="multipleTable" :border="false" :data="tableData" tooltip-effect="dark"
				style="font-size: 0.75rem;" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="selection" label="">
				</el-table-column>
				<el-table-column align="center" label="产品编号" width="150">
					<template slot-scope="scope">{{ scope.row.goods_sn }}</template>
				</el-table-column>
				<el-table-column align="center" label="产品信息" width="300" >
					<template slot-scope="scope">
						<div class="d-flex flex-row j-sb a-center">
							<img :src="scope.row.goods_thumb" alt=""
								style="width: 3.75rem;height: 3.75rem;margin-right: 0.69rem;border-radius: 0.25rem;">
							<div class="flex-1 d-flex flex-column j-sb a-start"
								style="line-height: 1;height: 3.75rem;text-align: left;">
								<span class="suojin">{{scope.row.goods_name}}</span>
								<span>发布时间{{scope.row.add_time}}</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="shop_price" label="价格" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" label="展示" width="100" >
					<template slot-scope="scope">
						<el-switch v-model="scope.row.is_confirm" @change="switchChange(scope.row)" active-color="#1E69FF" inactive-color="#B5CBF9">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="address" label="操作" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-button size="mini"
							style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="openDetail(scope.$index, scope.row)">查看</el-button>
						<el-button size="mini"
							style="background: #FF9D1F;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<i class="el-icon-delete" style="margin-left: 10px;cursor: pointer;font-size: 1.3rem;"
							@click="handleDelete(scope.$index, scope.row)"></i>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<footer class="d-flex j-sb a-center">
			<div class="d-flex a-center">
				<div @click="batchOffshelves" style="cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;margin-right: 2rem; text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #000000;border-radius: 0.625rem;">
					批量展示</div>
				<div @click="batchDelshelves" style="cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #000000;border-radius: 0.625rem;">
					批量删除</div>
			</div>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, total" :total="total_records">
			</el-pagination>
		</footer>
	</div>
</template>

<script>
	export default {
		props:{
			keyword: {
		        type: String,
		        default: null
		    }
		},
		data(){
			return {
				currentPage: 1, //初始页
				pageSize : 10,
				tableData: [],
				total_records : 0,
				goods_ids : [],
				status : ''
			}
		},
		methods: {
			getStockgoods(){
				let param = {
					act : 'enterprise_goods_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					status : 0,
					keyword : this.keyword,
					page : this.currentPage,
					size : this.pageSize
				}
				this.$api.login(param).then((res)=>{
					this.tableData = []
					if(res.code == 0){
						res.data.forEach((item) => {
							this.tableData.push({...item,is_confirm:item.status==1?true:false})
						})
						this.total_records = parseInt(res.total_records)
					}
				})
			},
			onoffGoods(status){
				let param = {
					act : status,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids : this.goods_ids.join(',')
				}
				this.$api.login(param).then((res)=>{
					if(res.code == 0){
						this.$message.success(res.msg)
						this.getStockgoods()
					}else{
						this.$message.error('操作失败')
					}
				})
			},
			delGoods(){
				let param = {
					act : 'enterprise_goods_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids : this.goods_ids.join(',')
				}
				this.$api.goods_list(param).then((res)=>{
					if(res.code == 0){
						this.$message.success(res.msg)
						this.getStockgoods()
					}else{
						this.$message.error('操作失败')
					}
				})
			},
			switchChange(item){
				if(item.is_confirm == true){
					let status = 'enterprise_goods_show'
					this.goods_ids.push(item.id)
					this.onoffGoods(status)
				}
			},
			batchOffshelves(){
				if(this.goods_ids.length == 0){
					this.$message.warning('请至少选择一个商品')
				}else{
					let status = 'enterprise_goods_show'
					this.onoffGoods(status)
				}
			},
			batchDelshelves(){
				if(this.goods_ids.length == 0){
					this.$message.warning('请至少选择一个商品')
				}else{
					this.$msgbox.confirm('是否确认此操作?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.delGoods()
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});  
					})
				}
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getStockgoods()
			},
			handleSelectionChange(val) {
				let goodsId = []
				val.forEach((item) => {
					goodsId.push(item.id)
				})
				this.goods_ids = goodsId
			},
			handleEdit(index, row) {
				row.editStatus = false
				row.editState = 0
				this.$router.push({path:'edit_item',query:row})
			},
			openDetail(index, row){
				row.editStatus = true
				row.editState = 1
				this.$router.push({path:'edit_item',query:row})
			},
			handleDelete(index, row) {
				this.$msgbox.confirm('是否确认此操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.goods_ids.push(row.id)
					this.delGoods()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});  
				})
			},
		},
		mounted() {
			this.getStockgoods()
			this.$nextTick(function() {
				this.$on('childmethods',function(){
					let param = {
						act : 'enterprise_goods_list',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						status : 0,
						keyword : this.keyword,
						page : this.currentPage,
						size : this.pageSize
					}
					this.$api.login(param).then((res)=>{
						this.tableData = []
						if(res.code == 0){
							res.data.forEach((item) => {
								this.tableData.push({...item,is_confirm:item.status==1?true:false})
							})
							this.total_records = parseInt(res.total_records)
						}
					})
				});
			});
		}
	}
</script>

<style lang="scss" scoped>
	.suojin{
		text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.stock_table{
		.table {
			margin-top: 1.44rem;
			width: 100%;
			background: #FFFFFF;
			border-radius: 6px;
			overflow: hidden;
		}
		footer {
			width: 100%;
			height: 3.85rem;
			background: #FFFFFF;
			margin-top: 1.44rem;
			border-radius: 6px;
			padding: 0 1.25rem;
			box-sizing: border-box;
		}
	}
</style>
